module.exports = __webpack_public_path__ + "img/pers-les-acteurs-du-projet.10b8f1e1.jpg";